// extracted by mini-css-extract-plugin
module.exports = {"content":"styles__content___3J6Xs","bookmarks":"styles__bookmarks___1_xg1","bookmarks--mobile":"styles__bookmarks--mobile___3ogQ7"};